import styled from "@emotion/styled";

const TableStyled = styled.table`
  border-collapse: collapse;
  margin: 0 auto;
  width: initial;
  max-width: 100%;
  min-width: 100%;
  text-align: left;

  th {
    border-bottom: solid 1px ${(props) => props.theme.colors.border2};
  }

  td,
  th {
    padding: 0.5rem 1.5rem 0.5rem 0;
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }

  tr {
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.colors.border2};
    &:last-of-type {
      border-bottom: none;
    }
  }

  thead {
    color: ${(props) => props.theme.text.colors.primary};
    background-color: ${(props) => props.theme.colors.background}66;
  }
`;

const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
  width: 100%;
  margin-bottom: 1rem;
`;

export const Table = (props: React.TableHTMLAttributes<HTMLTableElement>) => {
  return (
    <TableContainer>
      <TableStyled {...props} />
    </TableContainer>
  );
};
